import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const ConfigIdentificacionTipo = {

    async Get() {  return await methods.Get("ConfigIdentificacionTipo/Get" ) },
    async Post(data) { return await methods.Post("ConfigIdentificacionTipo/Post", data) },
    async Put(qs, data) { return await methods.Put("ConfigIdentificacionTipo/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("ConfigIdentificacionTipo/Delete" + useParamsJson(qs)) }
};

export default ConfigIdentificacionTipo;